import React, { useEffect } from "react";
import BackgroundImage from "../assets/images/about/mountain-sun.jpg";
import AboutImage1 from "../assets/images/about/periodic-table.jpg";
import AboutImage2 from "../assets/images/about/health.jpg";
import Layout from '../components/layout';
import Breadcrumbs from '../components/breadcrumbs';

const About = () => {
        useEffect(() => {
            window.scrollTo(0, 0);
          }, []);
    return (
        <div>
            <Layout>
            {/* Title Section */}
            <section
                className="bg-img1 txt-center p-lr-15 p-tb-92"
                style={{ backgroundImage: `url(${BackgroundImage})` }}
            >
                <h2 className="ltext-105 cl0 txt-center">About</h2>
            </section>

            <div className="container">
            <Breadcrumbs />
            </div>

            {/* Content Section */}
            <section className="full-page-section bg0 p-t-40 p-b-120">
                <div className="container">
                    {/* Our Story Section */}
                    <div className="row p-b-148">
                        <div className="col-md-7 col-lg-8">
                            <div className="p-t-7 p-r-85 p-r-15-lg p-r-0-md">
                                <h3 className="mtext-111 cl2 p-b-16">Our Story</h3>
                                <p className="stext-113 cl6 p-b-26">
                                After years of watching patients struggle with harsh hair loss treatments and disappointing natural remedies, 
                                I knew there had to be a better way. As both a chemist and naturopathic doctor, I was uniquely positioned to 
                                find it. The discovery of 2-deoxy-D-ribose's hair growth properties became the catalyst for Molu—a company 
                                dedicated to giving you the best of both medical worlds.
                                </p>
                                <p className="stext-113 cl6 p-b-26">
                                We believe effective hair restoration shouldn't come at the cost of your overall health. That's why our 
                                formulations combine the most proven ingredients from pharmaceutical and natural medicine, engineered to 
                                work harmoniously with your body's natural processes while delivering the results you've been promised but 
                                never received.
                                </p>
                                <p className="stext-113 cl6 p-b-26">
                                At Molu, your success defines our success. We've created complete wellness solutions that address hair growth 
                                from every angle—precision topical support combined with internal nourishment—because true, lasting 
                                transformation happens when science and nature work together, not against each other.
                                </p>
                            </div>
                        </div>
                        <div className="col-11 col-md-5 col-lg-4 m-lr-auto">
                            <div className="how-bor1">
                                <div className="hov-img0">
                                    <img src={AboutImage1} alt="Our Story" />
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Our Mission Section */}
                    <div className="row">
                        <div className="order-md-2 col-md-7 col-lg-8 p-b-30">
                            <div className="p-t-7 p-l-85 p-l-15-lg p-l-0-md">
                                <h3 className="mtext-111 cl2 p-b-16">Our Mission</h3>
                                <p className="stext-113 cl6 p-b-26">
                                At Molu, we believe everyone deserves to feel confident in their own skin. We bridge the gap between cutting-edge 
                                science and nature's wisdom to create hair wellness solutions that actually work. Through rigorous research and 
                                clinically-proven formulations, we transform hair loss from a life sentence into a solvable challenge. Your transformation 
                                isn't just our goal—it's our promise.

                                </p>
                                <div className="bor16 p-l-29 p-b-9 m-t-22">
                                    <p className="stext-114 cl6 p-r-40 p-b-11">
                                    Both health and sickness are the accumulation of small things that we do each day.
                                    </p>
                                    <span className="stext-111 cl8">- Molu Founder</span>
                                </div>
                            </div>
                        </div>
                        <div className="order-md-1 col-11 col-md-5 col-lg-4 m-lr-auto p-b-30">
                            <div className="how-bor2">
                                <div className="hov-img0">
                                    <img src={AboutImage2} alt="Our Mission" />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            </Layout>
        </div>
    );
};

export default About;
